<div class="reward-card-container">
  <div class="reward-card-content">
    <div class="click-content" (click)="onClickCard($event)">
      <div class="voucher-status-badge" *ngIf="cardType == cardTypes.used">
        <span class="status-badge">{{'label.used' | translate}}</span>
      </div>

      <div class="voucher-status-badge" *ngIf="cardType == cardTypes.expired">
        <span class="status-badge">{{'label.expired' | translate}}</span>
      </div>

      <div class="voucher-status-badge" *ngIf="cardType == cardTypes.full">
        <span class="status-badge">{{'button.fully.claimed' | translate}}</span>
      </div>

      <div class="rewardCard-voucher-info">
        <div class="image-container" *ngIf="imageData">
          <img [src]="imageData" alt="voucher image" loading="lazy" />
        </div>

        <div class="voucher-info">
          <h1 class="title truncateText"
            [ngClass]="{'disable' : cardType == cardTypes.used || cardType == cardTypes.expired || isBelowMinAmt}"
            *ngIf="vchTypTitle">{{vchTypTitle}}</h1>
          <p class="desc truncateText" [innerHtml]="vchTypDesc | highlightSearchText : searchText">{{ vchTypDesc }}</p>

          <ng-template
            [ngIf]="issueLimitMode > 0 &&  totalIssuedPercentage < 100 && (countDownTime?.length == 0 || countDownTime == null) && exploreReward && (cardType != cardTypes.used && cardType != cardTypes.expired )">
            <div class="progressbar-container">
              <p-progressBar [value]="totalIssuedPercentage" [showValue]="false"></p-progressBar>
              <p>{{ totalIssuedPercentage }}% <span class="text-claimed">{{
                  "label.claimed" | translate }}</span>
              </p>
            </div>
          </ng-template>

          <ng-template
            [ngIf]="countDownTime && countDownTime.length > 0 && exploreReward && (cardType != cardTypes.used && cardType != cardTypes.expired )">
            <div class="timer-container">
              <i class="icon-fire"></i>
              <span>{{ displayHr }}:</span><span>{{ displayMin }}:</span><span>{{ displaySc }}</span>
            </div>
          </ng-template>

        </div>
      </div>
    </div>

    <div class="action-container"
      *ngIf="cardType == cardTypes.store || cardType == cardTypes.claim || cardType == cardTypes.use">
      <app-button [buttonName]="'button.use'" (click)="onShowOtherStore()" class="border-btn"
        *ngIf="cardType == cardTypes.store"></app-button>

      <app-button [buttonName]="'button.claimable'" (click)="onClaim()" class="full-backrgound-btn"
        *ngIf="cardType == cardTypes.claim"></app-button>

      <app-button [buttonName]="'button.use'" (click)="onShowQr()" class="full-backrgound-btn"
        *ngIf="cardType == cardTypes.use"></app-button>
    </div>

    <div class="select-btn-container"
      *ngIf="myReward &&  (cardType === cardTypes.singleSelect || cardType === cardTypes.multiSelect)">
      <label class="checkbox-container singleSelect" *ngIf="cardType === cardTypes.singleSelect"
        (change)="onClickRadio($event)">
        <input type="checkbox" type="checkbox" id="select-voucher-{{ myReward.voucherNo }}"
          name="select-voucher-{{ myReward.vchCatgId }}" [checked]="isChecked" [disabled]="isBelowMinAmt" />
        <span class="checkmark"></span>
      </label>

      <label class="checkbox-container" *ngIf="cardType === cardTypes.multiSelect" (change)="onClickCheckbox($event)">
        <input type="checkbox" id="select-voucher-{{ myReward.voucherNo }}"
          name="select-voucher-{{ myReward.vchCatgId }}" [checked]="isChecked" [disabled]="isBelowMinAmt" />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>

  <ng-template [ngIf]="cardType == cardTypes.store || cardType == cardTypes.claim || cardType == cardTypes.use">
    <span class="node top"></span>
    <span class="node bottom"></span>
  </ng-template>
</div>